import styled from 'styled-components';
import { theme } from '../../styles';

export const RateWrapper = styled.div`
 display: ${props => props.showRate ? 'flex' : 'none'};
 align-items: baseline;
 padding-top: ${props => props.withoutPadding ? '0' : '4px'};
  li {
    color: ${theme.colors.fontTangerine};
  }
`;



// WEBPACK FOOTER //
// ./src/components/rate-pannel/styles.js